module.exports = __webpack_public_path__ + "img/nodata.0d95b46f.svg";